import type { DocumentData, DocumentReference, FieldValue } from 'firebase/firestore'
import { Timestamp } from 'firebase/firestore'

export class DocumentToSignModel {
  assignedToUser: DocumentReference | null
  documentPath: string | null
  documentName: string | null
  signedDocumentPath: string | null
  signedDocumentName: string | null
  signedTime: Timestamp | null
  expireTime: Timestamp | null
  status: string | null
  visibilityAccess: DocumentReference[] | null
  company: DocumentReference | null
  active: boolean
  agreementText: string | null

  createdByUser: DocumentReference | null
  lastUpdateByUser: DocumentReference | null
  lastUpdateTime: FieldValue | null

  reference: DocumentReference | null

  constructor(data: Partial<DocumentToSignModel>, reference?: DocumentReference | null) {
    this.assignedToUser = data.assignedToUser || null
    this.documentPath = data.documentPath || null
    this.documentName = data.documentName || null
    this.signedDocumentPath = data.signedDocumentPath || null
    this.signedDocumentName = data.signedDocumentName || null
    this.signedTime = data.signedTime instanceof Timestamp ? data.signedTime : data.signedTime || null
    this.expireTime = data.expireTime instanceof Timestamp ? data.expireTime : data.expireTime || null
    this.status = data.status || null
    this.visibilityAccess = data.visibilityAccess || null
    this.company = data.company || null
    this.active = data.active ?? true
    this.agreementText = data.agreementText || null

    this.createdByUser = data.createdByUser || null
    this.lastUpdateByUser = data.lastUpdateByUser || null
    this.lastUpdateTime = data.lastUpdateTime || null

    this.reference = reference || null
  }

  toMap() {
    return {
      assignedToUser: this.assignedToUser || null,
      documentPath: this.documentPath || null,
      documentName: this.documentName || null,
      signedDocumentPath: this.signedDocumentPath || null,
      signedDocumentName: this.signedDocumentName || null,
      signedTime: this.signedTime || null,
      expireTime: this.expireTime || null,
      status: this.status || null,
      visibilityAccess: this.visibilityAccess || null,
      company: this.company || null,
      active: this.active,
      agreementText: this.agreementText || null,
      lastUpdateTime: this.lastUpdateTime || null,
      lastUpdateByUser: this.lastUpdateByUser || null,
    }
  }
}

export function mapDocumentToSign(data: DocumentData): DocumentToSignModel {
  return new DocumentToSignModel(
    data.data(),
    data.ref,
  )
}
